module.exports = __webpack_public_path__ + "img/photo-team10.65683616.png";